import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable, finalize } from 'rxjs';

import { MpsLoaderService } from '../services/mps-loader.service';

@Injectable()
export class mpsLoaderInterceptor implements HttpInterceptor {
  private _loaderService = inject(MpsLoaderService);

  constructor(@Inject('LOADER_ON_HTTP') private loaderOnHttp: string) {}

  intercept(req: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    const id = this._loaderService.generateRandomId();
    if (this.loaderOnHttp) {
      this._loaderService.showLoader(id);
      return handler.handle(req).pipe(finalize(() => this._loaderService.hideLoader(id)));
    }

    return handler.handle(req);
  }
}
